/**
 * This file was @generated using pocketbase-typegen
 */

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
  AdminUsers = 'admin_users',
  BlogCategories = 'blog_categories',
  BlogPosts = 'blog_posts',
  Bookings = 'bookings',
  CollectionNames = 'collection_names',
  DashboardUsers = 'dashboard_users',
  Discounts = 'discounts',
  EmailInvitations = 'email_invitations',
  EmailTranslations = 'email_translations',
  EmailTypes = 'email_types',
  EventOffers = 'event_offers',
  Events = 'events',
  HomeSlides = 'home_slides',
  Insurances = 'insurances',
  Islands = 'islands',
  Leads = 'leads',
  LuggageTypes = 'luggage_types',
  Places = 'places',
  PurchaseItems = 'purchase_items',
  PurchaseStatuses = 'purchase_statuses',
  Purchases = 'purchases',
  Rates = 'rates',
  Roles = 'roles',
  ServiceTypes = 'service_types',
  ServicesPrices = 'services_prices',
  Translations = 'translations',
  Users = 'users',
  WrcClients = 'wrc_clients',
  WrcDiscountedClients = 'wrc_discounted_clients',
  WrcPlaces = 'wrc_places',
  WrcPurchases = 'wrc_purchases',
  WrcSaleOffer = 'wrc_sale_offer',
  WrcStages = 'wrc_stages',
  WrcTicketsUses = 'wrc_tickets_uses',
  WrcUsers = 'wrc_users'
}

// Alias types for improved usability
export type IsoDateString = string
export type RecordIdString = string
export type HTMLString = string

// System fields
export type BaseSystemFields<T = never> = {
  id: RecordIdString
  created: IsoDateString
  updated: IsoDateString
  collectionId: string
  collectionName: Collections
  expand?: T
}

export type AuthSystemFields<T = never> = {
  email: string
  emailVisibility: boolean
  username: string
  verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AdminUsersRecord = {
  role?: RecordIdString
}

export type BlogCategoriesRecord = {
  name?: string
}

export type BlogPostsRecord = {
  admin_user?: RecordIdString
  body?: HTMLString
  category?: RecordIdString
  title?: string
}

export type BookingsRecord = {
  booker_id?: number
  deleted?: boolean
  paxes?: number
  pmr_paxes?: number
  service_type?: RecordIdString
  user?: RecordIdString
}

export type CollectionNamesRecord = {
  name?: string
}

export type DashboardUsersRecord = {
  active?: boolean
  can_create?: RecordIdString[]
  can_delete?: RecordIdString[]
  can_update?: RecordIdString[]
  can_view: RecordIdString[]
}

export enum DiscountsTypeOptions {
  'percentage' = 'percentage',
  'amount' = 'amount'
}

export enum DiscountsInOutOptions {
  'in' = 'in',
  'out' = 'out',
  'other' = 'other'
}
export type DiscountsRecord = {
  amount?: number
  code?: string
  description?: string
  flight_from?: IsoDateString
  flight_until?: IsoDateString
  in_out: DiscountsInOutOptions[]
  island: RecordIdString[]
  limit_uses?: boolean
  message?: string
  service_type: RecordIdString[]
  type?: DiscountsTypeOptions
  user?: RecordIdString[]
  uses_left?: number
  valid_from: IsoDateString
  valid_until: IsoDateString
}

export type EmailInvitationsRecord = {
  company: string
  email: string
  external_booking_id?: string
  name: string
  phone?: string
}

export enum EmailTranslationsLangOptions {
  'es' = 'es',
  'en' = 'en'
}
export type EmailTranslationsRecord = {
  content: HTMLString
  content_key: string
  email_template_id?: string
  lang: EmailTranslationsLangOptions
}

export type EmailTypesRecord = {
  sender_email?: string
  sender_name?: string
  type?: string
}

export enum EventOffersTypeOptions {
  'to_event' = 'to_event',
  'from_event' = 'from_event',
  'round_trip' = 'round_trip'
}
export type EventOffersRecord<Tcoordinates = unknown> = {
  coordinates?: null | Tcoordinates
  description?: string
  enabled?: boolean
  event?: RecordIdString
  name?: string
  price?: number
  route?: string
  type?: EventOffersTypeOptions
}

export type EventsRecord = {
  date_from?: IsoDateString
  date_until?: IsoDateString
  description?: string
  enabled?: boolean
  image?: string
  name?: string
}

export type HomeSlidesRecord = {
  image: string
  name: string
  order: number
}

export type InsurancesRecord = {
  enabled?: boolean
  name?: string
}

export type IslandsRecord = {
  booker_id?: number
  enabled?: boolean
  name?: string
  short_name?: string
}

export enum LeadsSourceOptions {
  'landing' = 'landing'
}
export type LeadsRecord = {
  country: string
  email: string
  source?: LeadsSourceOptions
}

export type LuggageTypesRecord = {
  enabled?: boolean
  name?: string
}

export type PlacesRecord<Tcoordinates = unknown> = {
  coordinates: null | Tcoordinates
  google_id: string
  name: string
}

export enum PurchaseItemsTypeOptions {
  'booking' = 'booking',
  'luggage' = 'luggage',
  'luggage_service' = 'luggage_service',
  'insurance' = 'insurance',
  'refund' = 'refund',
  'points' = 'points'
}
export type PurchaseItemsRecord = {
  booking?: RecordIdString
  description?: string
  discount?: RecordIdString
  insurance_price?: number
  parent?: RecordIdString
  price?: number
  purchase?: RecordIdString
  type?: PurchaseItemsTypeOptions
}

export type PurchaseStatusesRecord = {
  name?: string
}

export type PurchasesRecord = {
  legal_terms?: boolean
  phone?: string
  privacy_terms?: boolean
  qr?: string
  status?: RecordIdString
  user?: RecordIdString
}

export type RatesRecord = {
  island: RecordIdString[]
  name?: string
  rate: number
  service_type: RecordIdString[]
  valid_from: IsoDateString
  valid_until: IsoDateString
}

export type RolesRecord = {
  enabled?: boolean
  name?: string
}

export type ServiceTypesRecord = {
  booker_id?: number
  enabled?: boolean
  name?: string
}

export enum ServicesPricesServiceTypeOptions {
  'shuttle' = 'shuttle',
  'wheelchair' = 'wheelchair',
  'private' = 'private',
  'luxury' = 'luxury'
}
export type ServicesPricesRecord = {
  price?: string
  service_type?: ServicesPricesServiceTypeOptions
}

export type TranslationsRecord = {
  content?: string
  key?: string
  lang?: string
}

export enum UsersSourceOptions {
  'rrss' = 'rrss',
  'google' = 'google',
  'tv' = 'tv',
  'agency' = 'agency',
  'friends' = 'friends'
}
export type UsersRecord = {
  accepts_commercial_comms?: boolean
  address?: string
  avatar?: string
  booker_id?: number
  country?: string
  deleted?: boolean
  last_lang?: string
  last_name?: string
  legal_terms?: boolean
  name?: string
  nif?: string
  phone?: string
  postal_code?: string
  privacy_terms?: boolean
  referrer?: string
  source?: UsersSourceOptions
  token?: string
}

export type WrcClientsRecord = {
  accept_legal_terms?: boolean
  accept_privacy_terms?: boolean
  email: string
  first_name: string
  last_name: string
  newsletter?: boolean
  origin?: string
  phone_number: number
}

export type WrcDiscountedClientsRecord = {
  completed_count?: number
}

export type WrcPlacesRecord = {
  comments?: string
  latitude: number
  longitude: number
  name: string
}

export enum WrcPurchasesStatusOptions {
  'pending' = 'pending',
  'completed' = 'completed',
  'failed' = 'failed',
  'expired' = 'expired'
}
export type WrcPurchasesRecord = {
  client: RecordIdString
  paxes: number
  pmr_paxes?: number
  qr_image?: string
  sale_offer: RecordIdString
  status: WrcPurchasesStatusOptions
  total_price?: number
  transaction_id?: string
}

export type WrcSaleOfferRecord = {
  comments?: string
  end_place: RecordIdString
  end_time_window: string
  is_available?: boolean
  round_trip_price: number
  stage: RecordIdString
  start_place: RecordIdString
  start_time_window: string
}

export type WrcStagesRecord = {
  date: string
  name: string
}

export enum WrcTicketsUsesTypeOptions {
  'in' = 'in',
  'out' = 'out'
}
export type WrcTicketsUsesRecord = {
  driver?: RecordIdString
  purchase?: RecordIdString
  type?: WrcTicketsUsesTypeOptions
}

export type WrcUsersRecord = {
  fullname?: string
}

// Response types include system fields and match responses from the PocketBase API
export type AdminUsersResponse<Texpand = unknown> = Required<AdminUsersRecord> & AuthSystemFields<Texpand>
export type BlogCategoriesResponse<Texpand = unknown> = Required<BlogCategoriesRecord> & BaseSystemFields<Texpand>
export type BlogPostsResponse<Texpand = unknown> = Required<BlogPostsRecord> & BaseSystemFields<Texpand>
export type BookingsResponse<Texpand = unknown> = Required<BookingsRecord> & BaseSystemFields<Texpand>
export type CollectionNamesResponse<Texpand = unknown> = Required<CollectionNamesRecord> & BaseSystemFields<Texpand>
export type DashboardUsersResponse<Texpand = unknown> = Required<DashboardUsersRecord> & AuthSystemFields<Texpand>
export type DiscountsResponse<Texpand = unknown> = Required<DiscountsRecord> & BaseSystemFields<Texpand>
export type EmailInvitationsResponse<Texpand = unknown> = Required<EmailInvitationsRecord> & BaseSystemFields<Texpand>
export type EmailTranslationsResponse<Texpand = unknown> = Required<EmailTranslationsRecord> & BaseSystemFields<Texpand>
export type EmailTypesResponse<Texpand = unknown> = Required<EmailTypesRecord> & BaseSystemFields<Texpand>
export type EventOffersResponse<Tcoordinates = unknown, Texpand = unknown> = Required<EventOffersRecord<Tcoordinates>> &
  BaseSystemFields<Texpand>
export type EventsResponse<Texpand = unknown> = Required<EventsRecord> & BaseSystemFields<Texpand>
export type HomeSlidesResponse<Texpand = unknown> = Required<HomeSlidesRecord> & BaseSystemFields<Texpand>
export type InsurancesResponse<Texpand = unknown> = Required<InsurancesRecord> & BaseSystemFields<Texpand>
export type IslandsResponse<Texpand = unknown> = Required<IslandsRecord> & BaseSystemFields<Texpand>
export type LeadsResponse<Texpand = unknown> = Required<LeadsRecord> & BaseSystemFields<Texpand>
export type LuggageTypesResponse<Texpand = unknown> = Required<LuggageTypesRecord> & BaseSystemFields<Texpand>
export type PlacesResponse<Tcoordinates = unknown, Texpand = unknown> = Required<PlacesRecord<Tcoordinates>> & BaseSystemFields<Texpand>
export type PurchaseItemsResponse<Texpand = unknown> = Required<PurchaseItemsRecord> & BaseSystemFields<Texpand>
export type PurchaseStatusesResponse<Texpand = unknown> = Required<PurchaseStatusesRecord> & BaseSystemFields<Texpand>
export type PurchasesResponse<Texpand = unknown> = Required<PurchasesRecord> & BaseSystemFields<Texpand>
export type RatesResponse<Texpand = unknown> = Required<RatesRecord> & BaseSystemFields<Texpand>
export type RolesResponse<Texpand = unknown> = Required<RolesRecord> & BaseSystemFields<Texpand>
export type ServiceTypesResponse<Texpand = unknown> = Required<ServiceTypesRecord> & BaseSystemFields<Texpand>
export type ServicesPricesResponse<Texpand = unknown> = Required<ServicesPricesRecord> & BaseSystemFields<Texpand>
export type TranslationsResponse<Texpand = unknown> = Required<TranslationsRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> & AuthSystemFields<Texpand>
export type WrcClientsResponse<Texpand = unknown> = Required<WrcClientsRecord> & BaseSystemFields<Texpand>
export type WrcDiscountedClientsResponse<Texpand = unknown> = Required<WrcDiscountedClientsRecord> & BaseSystemFields<Texpand>
export type WrcPlacesResponse<Texpand = unknown> = Required<WrcPlacesRecord> & BaseSystemFields<Texpand>
export type WrcPurchasesResponse<Texpand = unknown> = Required<WrcPurchasesRecord> & BaseSystemFields<Texpand>
export type WrcSaleOfferResponse<Texpand = unknown> = Required<WrcSaleOfferRecord> & BaseSystemFields<Texpand>
export type WrcStagesResponse<Texpand = unknown> = Required<WrcStagesRecord> & BaseSystemFields<Texpand>
export type WrcTicketsUsesResponse<Texpand = unknown> = Required<WrcTicketsUsesRecord> & BaseSystemFields<Texpand>
export type WrcUsersResponse<Texpand = unknown> = Required<WrcUsersRecord> & AuthSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
  admin_users: AdminUsersRecord
  blog_categories: BlogCategoriesRecord
  blog_posts: BlogPostsRecord
  bookings: BookingsRecord
  collection_names: CollectionNamesRecord
  dashboard_users: DashboardUsersRecord
  discounts: DiscountsRecord
  email_invitations: EmailInvitationsRecord
  email_translations: EmailTranslationsRecord
  email_types: EmailTypesRecord
  event_offers: EventOffersRecord
  events: EventsRecord
  home_slides: HomeSlidesRecord
  insurances: InsurancesRecord
  islands: IslandsRecord
  leads: LeadsRecord
  luggage_types: LuggageTypesRecord
  places: PlacesRecord
  purchase_items: PurchaseItemsRecord
  purchase_statuses: PurchaseStatusesRecord
  purchases: PurchasesRecord
  rates: RatesRecord
  roles: RolesRecord
  service_types: ServiceTypesRecord
  services_prices: ServicesPricesRecord
  translations: TranslationsRecord
  users: UsersRecord
  wrc_clients: WrcClientsRecord
  wrc_discounted_clients: WrcDiscountedClientsRecord
  wrc_places: WrcPlacesRecord
  wrc_purchases: WrcPurchasesRecord
  wrc_sale_offer: WrcSaleOfferRecord
  wrc_stages: WrcStagesRecord
  wrc_tickets_uses: WrcTicketsUsesRecord
  wrc_users: WrcUsersRecord
}

export type CollectionResponses = {
  admin_users: AdminUsersResponse
  blog_categories: BlogCategoriesResponse
  blog_posts: BlogPostsResponse
  bookings: BookingsResponse
  collection_names: CollectionNamesResponse
  dashboard_users: DashboardUsersResponse
  discounts: DiscountsResponse
  email_invitations: EmailInvitationsResponse
  email_translations: EmailTranslationsResponse
  email_types: EmailTypesResponse
  event_offers: EventOffersResponse
  events: EventsResponse
  home_slides: HomeSlidesResponse
  insurances: InsurancesResponse
  islands: IslandsResponse
  leads: LeadsResponse
  luggage_types: LuggageTypesResponse
  places: PlacesResponse
  purchase_items: PurchaseItemsResponse
  purchase_statuses: PurchaseStatusesResponse
  purchases: PurchasesResponse
  rates: RatesResponse
  roles: RolesResponse
  service_types: ServiceTypesResponse
  services_prices: ServicesPricesResponse
  translations: TranslationsResponse
  users: UsersResponse
  wrc_clients: WrcClientsResponse
  wrc_discounted_clients: WrcDiscountedClientsResponse
  wrc_places: WrcPlacesResponse
  wrc_purchases: WrcPurchasesResponse
  wrc_sale_offer: WrcSaleOfferResponse
  wrc_stages: WrcStagesResponse
  wrc_tickets_uses: WrcTicketsUsesResponse
  wrc_users: WrcUsersResponse
}

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = PocketBase & {
  collection(idOrName: 'admin_users'): RecordService<AdminUsersResponse>
  collection(idOrName: 'blog_categories'): RecordService<BlogCategoriesResponse>
  collection(idOrName: 'blog_posts'): RecordService<BlogPostsResponse>
  collection(idOrName: 'bookings'): RecordService<BookingsResponse>
  collection(idOrName: 'collection_names'): RecordService<CollectionNamesResponse>
  collection(idOrName: 'dashboard_users'): RecordService<DashboardUsersResponse>
  collection(idOrName: 'discounts'): RecordService<DiscountsResponse>
  collection(idOrName: 'email_invitations'): RecordService<EmailInvitationsResponse>
  collection(idOrName: 'email_translations'): RecordService<EmailTranslationsResponse>
  collection(idOrName: 'email_types'): RecordService<EmailTypesResponse>
  collection(idOrName: 'event_offers'): RecordService<EventOffersResponse>
  collection(idOrName: 'events'): RecordService<EventsResponse>
  collection(idOrName: 'home_slides'): RecordService<HomeSlidesResponse>
  collection(idOrName: 'insurances'): RecordService<InsurancesResponse>
  collection(idOrName: 'islands'): RecordService<IslandsResponse>
  collection(idOrName: 'leads'): RecordService<LeadsResponse>
  collection(idOrName: 'luggage_types'): RecordService<LuggageTypesResponse>
  collection(idOrName: 'places'): RecordService<PlacesResponse>
  collection(idOrName: 'purchase_items'): RecordService<PurchaseItemsResponse>
  collection(idOrName: 'purchase_statuses'): RecordService<PurchaseStatusesResponse>
  collection(idOrName: 'purchases'): RecordService<PurchasesResponse>
  collection(idOrName: 'rates'): RecordService<RatesResponse>
  collection(idOrName: 'roles'): RecordService<RolesResponse>
  collection(idOrName: 'service_types'): RecordService<ServiceTypesResponse>
  collection(idOrName: 'services_prices'): RecordService<ServicesPricesResponse>
  collection(idOrName: 'translations'): RecordService<TranslationsResponse>
  collection(idOrName: 'users'): RecordService<UsersResponse>
  collection(idOrName: 'wrc_clients'): RecordService<WrcClientsResponse>
  collection(idOrName: 'wrc_discounted_clients'): RecordService<WrcDiscountedClientsResponse>
  collection(idOrName: 'wrc_places'): RecordService<WrcPlacesResponse>
  collection(idOrName: 'wrc_purchases'): RecordService<WrcPurchasesResponse>
  collection(idOrName: 'wrc_sale_offer'): RecordService<WrcSaleOfferResponse>
  collection(idOrName: 'wrc_stages'): RecordService<WrcStagesResponse>
  collection(idOrName: 'wrc_tickets_uses'): RecordService<WrcTicketsUsesResponse>
  collection(idOrName: 'wrc_users'): RecordService<WrcUsersResponse>
}
